<template>
	<PButton
		class="header-button"
		:class="{
			'rounded-4': !isXS,
			'bg-neutral-25 rounded-4 shadow-xs': isActive && !isXS,
			'd-flex flex-column mt-3 align-center justify-center header-button-mobile': isXS,
		}"
		:icon="buttonIcon"
		type="text"
		:size="isXS ? 'xl' : 'md'"
		:color="isActive ? 'primary' : 'neutral'"
		@click="$emit('click')"
		@mousedown="handleMouseDown"
	>
		{{ text }}
	</PButton>
</template>
<script setup lang="ts">
	import { computed } from 'vue'

	interface Props {
		icon: string
		text: string
		isXS?: boolean
		isActive?: boolean
	}

	const props = defineProps<Props>()
	defineEmits(['click'])

	const buttonIcon = computed((): string => {
		let icon = props.icon
		if (props.isActive) icon = icon + '-filled'
		return icon
	})

	const handleMouseDown = (event: MouseEvent) => {
		if (props.isActive) event.preventDefault()
	}
</script>

<style lang="css">
	.header-button-mobile {
		min-height: 60px;
	}

	.header-button i {
		margin-right: 0;
	}
</style>
